import React, { useState, useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// components
import { Avatar, Text } from './..'

// icons
import { Chevron } from '../Svg'

// styles
import styles from './Drawer.module.scss'

const Drawer = ({
  imageSrc,
  text,
  subtext,
  children,
  className,
  disabled,
  onClick,
  expanded,
}) => {
  const [height, setHeight] = useState(0)
  const expandingDiv = useRef()
  const handleClick = useCallback(
    (e) => {
      const node = expandingDiv.current
      if (node) {
        const height = node.getBoundingClientRect().height
        setHeight(height)
      }
      onClick && onClick(e)
    },
    [onClick]
  )

  const expandingHeightStyle = { height: expanded ? 'auto' : `${height}px` }

  return (
    <div
      className={classnames(
        styles.drawer,
        className,
        expanded && styles.expanded
      )}
    >
      <div className={styles.helpContainer} onClick={handleClick}>
        <Avatar className={styles.avatar} src={imageSrc} />
        <div className={styles.textItem}>
          <Text
            size="l"
            color="gray"
            letterSpacing="normal"
            className={styles.drawerText}
          >
            {text}
          </Text>
          <Text
            size="s"
            color="heather"
            letterSpacing="normal"
            className={styles.drawerSubtext}
          >
            {subtext}
          </Text>
        </div>
        <div
          className={classnames(
            styles.iconContainer,
            disabled && styles.disabled
          )}
        >
          <Chevron
            className={classnames(
              styles.notSelected,
              className,
              expanded && styles.selected
            )}
          />
        </div>
      </div>
      <div
        ref={expandingDiv}
        className={classnames(styles.expandedRow, !expanded && styles.hidden)}
        style={expandingHeightStyle}
      >
        {children}
      </div>
    </div>
  )
}

Drawer.propTypes = {
  className: PropTypes.string,
  imageSrc: PropTypes.string,
  text: PropTypes.string,
  subtext: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string,
  ]),
  disabled: PropTypes.bool,
  status: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
}

export default Drawer
